export const LOGIN_USER_NEW_PASSWORD_REQUIRED = 'LOGIN_USER_NEW_PASSWORD_REQUIRED';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const TOKEN_USER_SUCCESS = 'TOKEN_USER_SUCCESS';
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';

export const NAVIANCE_ADMIN_ROLE = 'https://oauth.naviance.com/oauth/claims/community.admin';
export const NAVIANCE_MEMBER_ROLE = 'https://oauth.naviance.com/oauth/claims/community.member';
export const SCHOOL_ID = 'https://oauth.naviance.com/oauth/claims/school.id';

export const NON_NAVIANCE_ADMIN_ROLE = 'admin';
export const NON_NAVIANCE_MEMBER_ROLE = 'member';

export const HUBS_SUBSCRIPTION = 'HUBPAGE';
export const COMMMUNITY_SUBSCRIPTION = 'COMMUNITY';
export const MATCHING_SUBSCRIPTION = 'MATCHING';
export const INLINE_MANUAL = 'INLINE_MANUAL';
export const COMMUNITY_SERVERLESS = 'COMMUNITYSERVERLESS';
export const DISABLE_LEGACY_COMMUNITY = 'DISABLE_LEGACY_COMMUNITY';
export const ENABLE_PERSONALIZED_COLLEGE_PROFILE = 'feature.personalizedProfile.college.enablePersonalizedProfile';

export const NAVIANCE_APP_ROLES = [
  NAVIANCE_ADMIN_ROLE, NAVIANCE_MEMBER_ROLE,
];

export const NON_NAVIANCE_APP_ROLES = [
  NON_NAVIANCE_ADMIN_ROLE, NON_NAVIANCE_MEMBER_ROLE,
];
